export class PageLayout {
  id?: string;
  height?:number;
  name?: string;
  unit?: string;
  width?: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/pageLayout.ts